// Rails entry point — `react_component 'Proposals/SendProposal', { proposal: ... }`.
//
// The implementation lives in SendProposalModalView.tsx (NOT named after the
// directory): webpack's require.context resolution treats a sibling file named
// after its parent directory as a self-import, yielding an undefined export at
// runtime (see Invoices/SendInvoiceModal and Invoices/QboTaxPrecheck for the same
// gotcha).
//
// Renders the Send control and the dialog together. The dialog is mounted only
// while open, so it starts clean on every send — unlike the invoice equivalent,
// which stays mounted and has to re-apply its defaults when `isOpen` flips.
import React, { useCallback, useState } from 'react';
import { translate } from '@utils/i18n';
import { viewAndAcceptProposalsPath } from '@routes';
import SendProposalModalView from './SendProposalModalView';
const namespace = 'features.proposals.send_proposal';
export default function Index({ proposal }) {
    const [isSendModalOpen, setSendModalOpen] = useState(false);
    // The dialog's preview is view_and_accept.pdf, generated on demand — roughly 1.7s of
    // server time — and `Modal` renders nothing while closed, so the request cannot start
    // until the dialog opens. Warm it on hover and focus, which is when intent shows.
    const prefetchPreview = useCallback(() => {
        if (!proposal.emailUrlUuid)
            return;
        const href = viewAndAcceptProposalsPath({ token: proposal.emailUrlUuid, format: 'pdf' });
        if (document.head.querySelector(`link[rel="prefetch"][href="${href}"]`))
            return;
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'document';
        link.href = href;
        document.head.appendChild(link);
    }, [proposal.emailUrlUuid]);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: "qmb-control--primary", onMouseEnter: prefetchPreview, onFocus: prefetchPreview, onClick: () => setSendModalOpen(true) },
            React.createElement("i", { className: "fa-light fa-paper-plane-top", "aria-hidden": "true" }),
            translate('send', { namespace })),
        isSendModalOpen && React.createElement(SendProposalModalView, { proposal: proposal, onClose: () => setSendModalOpen(false) })));
}
